import Vue from 'vue'
import Router from 'vue-router'
import AuthMixin, { enforceAuth } from './mixins/auth'
import { checkEventName } from './mixins/events'
import LoginView from './views/LoginView.vue'
import HomeView from './views/HomeView.vue'

// These are loaded on an as-needed basis
const EventView = () => import('./views/EventView')
const EventAddEditView = () => import('./views/EventAddEditView')
const SettingsView = () => import('./views/SettingsView')
const PaymentsView = () => import('./views/PaymentsView')
const ManageHostsView = () => import('./views/ManageHostsView')
const AdminMetricsView = () => import('./views/AdminMetricsView')
const NotFoundView = () => import('./views/NotFoundView')

Vue.use(Router)

Vue.mixin({
  // This exposes isLoggedIn and isAdmin
  // computed properties to all instances
  computed: AuthMixin.computed,

  // This allows routes to be authenticated based
  // on values in their meta. For example, if a
  // route specifies mustBeLoggedIn in its meta and
  // there is no user set for the component, it will
  // redirect to the login screen
  beforeRouteEnter: enforceAuth
})

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: LoginView
    },
    {
      path: '/home',
      name: 'home',
      component: HomeView,
      meta: {
        mustBeLoggedIn: true
      }
    },
    {
      path: '/event/add',
      name: 'addEvent',
      component: EventAddEditView,
      meta: {
        mustBeLoggedIn: true
      }
    },
    {
      path: '/event/:name/edit',
      name: 'editEvent',
      component: EventAddEditView,
      beforeEnter: checkEventName,
      meta: {
        mustBeLoggedIn: true
      }
    },
    {
      path: '/event/:name',
      name: 'showEvent',
      component: EventView,
      beforeEnter: checkEventName,
      props: true,
      meta: {
        mustBeLoggedIn: true
      }
    },
    {
      path: '/payments',
      name: 'payments',
      component: PaymentsView,
      meta: {
        mustBeLoggedIn: true
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: SettingsView,
      meta: {
        mustBeLoggedIn: true
      }
    },
    {
      path: '/admin/manage-hosts',
      name: 'manageHosts',
      component: ManageHostsView,
      meta: {
        mustBeLoggedIn: true,
        mustBeAdmin: true
      }
    },
    {
      path: '/admin/metrics',
      name: 'adminMetrics',
      component: AdminMetricsView,
      meta: {
        mustBeLoggedIn: true,
        mustBeAdmin: true
      }
    },
    {
      path: '*',
      name: 'notFound',
      component: NotFoundView
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.path === '/') {
      return { x: 0, y: 0 }
    }
  }
})
